import { State } from 'store/main';
import { camelCaseToSnakeCase } from 'utils/string';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const extractFilters = (searchFacets, filters: Record<string, any>) => {
  const result = {};
  Object.keys(filters).forEach((filterKey) => {
    let value = filters[filterKey];

    if (searchFacets[filterKey] && value === searchFacets[filterKey].options) {
      value = 'ALL';
    }

    result[`filter_${camelCaseToSnakeCase(filterKey)}`] = value;
  });
  return result;
};

export const extractLocationProperties = (location: SearchLocation) => ({
  location_geo_type: location.geoType,
  location_latitude: location.latitude,
  location_longitude: location.longitude,
  location_state: location.stateCode,
  location_text: location.text,
});

const getMainSearchTrackingData = (
  {
    mainSearch: {
      initialized,
      searchFacets,
      filters,
      query,
      pageIndex,
      resultsByPage,
    },
    currentUser,
    searchRadius: { value: radius },
  }: State,
  searchFrom?: string
) => {
  if (initialized && currentUser && currentUser.searchLocation) {
    const { searchLocation } = currentUser;
    const results = resultsByPage[pageIndex.toString()] || {
      nbHits: 0,
      nbPages: 0,
    };
    return {
      current_page: pageIndex + 1,
      geo_location_enabled: !!searchLocation.latitude,
      ...extractFilters(searchFacets, filters),
      search_query: query,
      search_radius: radius,
      number_of_results: results.nbHits,
      number_of_pages: results.nbPages,
      search_from: searchFrom,
      ...extractLocationProperties(searchLocation),
    };
  }

  return {};
};

export default getMainSearchTrackingData;
